import { t } from 'i18next';
import * as yup from 'yup';

import { testRequiredSchema } from 'coreOld/schemas';

export const signInFormSchema = (required = true) =>
  yup.object().shape({
    email: yup.string().trim().label(t('labelEmailAddress')).email().nullable().required(),
    password: yup
      .string()
      .label(t('labelPassword'))
      .nullable()
      .test(...testRequiredSchema(required, 'Password')),
  });
